(function(){
'use strict';
var KEY='__PP_HAT_OFFER_V1';
if(window[KEY]){window[KEY].refresh();return;}
var ELIGIBLE={15472216309984:true,15472267526368:true,15472312221920:true,15472404267232:true,15472411443424:true}, HAT_ID=15472267526368, LABEL='3_disfraces_50';
function qualifying(item){return !!ELIGIBLE[Number(item.product_id)]&&!(item.properties&&item.properties._pp_promo_hat);}
var BASE=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
BASE=BASE.replace(/\/?$/,'/');
var state={count:0,hatInCart:false,taggedKey:null,busy:false,removing:false,offerVariant:null};
function normalize(x){var n=Number(x);return Number.isFinite(n)?Math.max(0,n):0;}
function promoLine(item){return normalize(item.product_id)===HAT_ID && item.properties&&item.properties._pp_promo_hat===LABEL;}
function sync(cart){
 var units=0,hasHat=false,tagged=null;
 (cart.items||[]).forEach(function(item){
   if(qualifying(item))units+=normalize(item.quantity);
   if(normalize(item.product_id)===HAT_ID){hasHat=true;if(promoLine(item))tagged=item;}
 });
 state.count=units;state.hatInCart=hasHat;state.taggedKey=tagged&&tagged.key||null;
 document.querySelectorAll('[data-pp-hat-offer]').forEach(function(el){
   el.hidden=units<2;
   if(units<2)return;
   var choice=el.querySelector('[data-pp-hat-choice]'),added=el.querySelector('[data-pp-hat-added]'),btn=el.querySelector('[data-pp-hat-add]'),select=el.querySelector('[data-pp-hat-variant]');
   var present=!!tagged;
   if(choice)choice.hidden=present;
   if(added){added.hidden=!present;added.textContent=present?'✅ ¡Gorrito añadido! Revisa el descuento aplicado antes de pagar.':'';}
   if(btn){btn.disabled=state.busy||!select||!select.value;}
 });
 if(units<2 && tagged && !state.removing){
    state.removing=true;
    change({id:tagged.key,quantity:0}).then(function(c){state.removing=false;sync(c);updateTheme(c);}).catch(function(){state.removing=false;});
 }
}
async function cartRead(){
 var r=await fetch(BASE+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
 if(!r.ok)throw Error('No se pudo leer el carrito');
 return await r.json();
}
async function change(obj){
 var r=await fetch(BASE+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(obj)});
 var c=await r.json();if(!r.ok)throw Error(c.description||'No se pudo retirar el gorrito');return c;
}
async function updateTheme(cart){
 try{
   var r=await fetch(BASE+'?sections=cart-drawer,cart-icon-bubble',{credentials:'same-origin',cache:'no-store'});
   if(!r.ok)return;
   var sections=await r.json(),drawer=document.querySelector('cart-drawer');
   if(drawer && sections['cart-drawer']){
     var doc=new DOMParser().parseFromString(sections['cart-drawer'],'text/html');
     var newer=doc.querySelector('#CartDrawer'),current=drawer.querySelector('#CartDrawer');
     if(newer&&current)current.replaceWith(newer);
   }
   var bubble=document.querySelector('#cart-icon-bubble');
   if(bubble&&sections['cart-icon-bubble']){
     var fragment=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
     var next=fragment.querySelector('#cart-icon-bubble');
     if(next)bubble.replaceWith(next);
   }
 }catch(e){}
 document.dispatchEvent(new Event('cart:updated'));
 if(window.__PP_REWARDS_CART_V4)window.__PP_REWARDS_CART_V4.schedule(150);
}
async function add(variant){
 if(state.busy)return;
 state.busy=true;
 document.querySelectorAll('[data-pp-hat-add]').forEach(function(x){x.disabled=true;x.textContent='Añadiendo gorrito…';});
 try{
  var latest=await cartRead();
  var count=(latest.items||[]).reduce(function(a,item){return a+(qualifying(item)?normalize(item.quantity):0);},0);
  if(count<2)throw Error('Necesitas 2 productos participantes para activar esta oferta.');
  if((latest.items||[]).some(promoLine)){sync(latest);return;}
  var req=await fetch(BASE+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:normalize(variant),quantity:1,properties:{_pp_promo_hat:LABEL}}]})});
  var result=await req.json();if(!req.ok)throw Error(result.description||'No se pudo añadir el gorrito');
  var cart=await cartRead();sync(cart);await updateTheme(cart);
 }catch(err){
  document.querySelectorAll('[data-pp-hat-error]').forEach(function(e){e.hidden=false;e.textContent=err.message||'No se pudo añadir el gorrito';});
 }finally{
  state.busy=false;
  document.querySelectorAll('[data-pp-hat-add]').forEach(function(x){x.textContent='Agregar gorrito al 50% →';x.disabled=!x.closest('[data-pp-hat-offer]').querySelector('[data-pp-hat-variant]').value;});
 }
}
function refresh(){cartRead().then(sync).catch(function(){})}
window[KEY]={sync:sync,refresh:refresh};
function syncVisualPicker(root){
 if(!root)return;
 var activeModel=root.querySelector('[data-pp-hat-model][aria-pressed="true"]');
 var activeSize=root.querySelector('[data-pp-hat-size][aria-pressed="true"]');
 var model=activeModel?activeModel.getAttribute('data-pp-hat-model'):'';
 var size=activeSize?activeSize.getAttribute('data-pp-hat-size'):'';
 var select=root.querySelector('[data-pp-hat-variant]'),button=root.querySelector('[data-pp-hat-add]');
 var notice=root.querySelector('[data-pp-hat-selection-text]');
 var desired=null;
 if(select && model && size){desired=Array.from(select.options).find(function(option){return option.dataset.model===model&&option.dataset.size===size;});}
 if(select)select.value=desired?desired.value:'';
 if(button)button.disabled=!desired||state.busy;
 if(notice){
  if(desired)notice.textContent='Gorrito navideño · '+(activeModel.getAttribute('data-pp-hat-model-label')||model)+' · Talla '+size+' · 50% de descuento';
  else if(model)notice.textContent='Elegiste '+(activeModel.getAttribute('data-pp-hat-model-label')||model)+'. Ahora selecciona una talla.';
  else if(size)notice.textContent='Elegiste talla '+size+'. Ahora elige tu diseño.';
  else notice.textContent='Elige diseño y talla para continuar.';
 }
 var err=root.querySelector('[data-pp-hat-error]');if(err)err.hidden=true;
}
document.addEventListener('click',function(e){
 var tile=e.target.closest('[data-pp-hat-model]');var sizeBtn=e.target.closest('[data-pp-hat-size]');
 var pressed=tile||sizeBtn;
 if(!pressed)return;
 var root=pressed.closest('[data-pp-hat-offer]');if(!root)return;
 e.preventDefault();
 if(tile){root.querySelectorAll('[data-pp-hat-model]').forEach(function(x){x.setAttribute('aria-pressed',String(x===tile));});}
 if(sizeBtn){root.querySelectorAll('[data-pp-hat-size]').forEach(function(x){x.setAttribute('aria-pressed',String(x===sizeBtn));});}
 syncVisualPicker(root);
},true);
document.addEventListener('click',function(e){
 var btn=e.target.closest('[data-pp-hat-add]');if(!btn)return;
 var root=btn.closest('[data-pp-hat-offer]'),select=root&&root.querySelector('[data-pp-hat-variant]');
 if(select&&select.value){e.preventDefault();add(select.value);}
},true);
document.addEventListener('cart:updated',function(){refresh();});
document.addEventListener('cart:refresh',function(){refresh();});
document.addEventListener('shopify:section:load',function(){refresh();});
document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
refresh();
})();